import { child, set } from "firebase/database";
import { doc, setDoc } from "firebase/firestore";
import { PiniaPluginContext } from "pinia";
import { JobAction } from "@/interface/job";
import dayjs from "dayjs"

function MyPiniaPlugin({ store }: PiniaPluginContext) {
  if (store.$id == "jobs") {
    const offlineService = useOffline();
    const firestoreDb = useFirebaseFirestore();

    //window.ABC_RICE = store
    setTimeout(() => {
      restore()
    }, 6000);
    // jobs from my machine sync to cloud
    store.$onAction(
      ({
        name, // name of the action
        store, // store instance, same as `someStore`
        args, // array of parameters passed to the action
        after, // hook after the action returns or resolves
        onError, // hook if the action throws or rejects
      }) => {
        let job = args[0];
        let syncToCloud = args[1];
        // โหมด Audit: jobs.add บล็อก job ไว้แล้ว แต่ $onAction ยิงก่อนตัว action
        if (name == "add" && syncToCloud && !isAuditMode()) {
          if (job.action == JobAction.VOID) {
            saveJobToCloud(job);
          }
        }
      }
    );

    function saveJobToCloud(job) {
      const storeId = useStoreId();
      // ต่อโต๊ะท้าย key ด้วยเหตุผลเดียวกับ jobchain
      // ไม่งั้น void สองใบจากคนละเครื่องที่ชน millisecond จะทับกัน แล้วรายงาน void หายไปใบหนึ่ง
      const addTime = dayjs(job.timestamp).add(1,'second').toISOString()
      let key = utilsJobKey({ ...job, timestamp: addTime });
      let type = "voidItem";
      let payload = {
        data: {
          ...job,
          storeId,
          nonce: store.nonce,
        },
        type: type,
        key: key,
      };

  
      offlineService.save(key, type, payload);
      const voidItemRef = firestoreDb.voidItemCollectionRef();
      const docRef = doc(voidItemRef, key);

      setDoc(docRef, payload)
        .then(() => offlineService.release(key))
        .catch((e) => {
          console.log(e);
        });
    }

    function restore() {
      let jobs = offlineService.getItemsByType("voidItem");

      const storeId = useStoreId();
      jobs.forEach((job) => {
        if (job.data.storeId != storeId) {
          return;
        }
        const voidItemRef = firestoreDb.voidItemCollectionRef();
        const docRef = doc(voidItemRef, job.key);
        setDoc(docRef, job.data)
          .then(() => offlineService.release(job.key))
          .catch((e) => {
            console.log(e);
          });
      });
    }
  }
}

export default defineNuxtPlugin(({ $pinia }) => {
  $pinia.use(MyPiniaPlugin);
});
